import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  Button,
  EmptyState,
  Loading,
  Stack,
} from "@rentiohq/web-shared/dist/components";
import { TMissingDetailState } from "../missingDetail.utils";

type TDetailKind = "cost" | "settlement";

interface IProps {
  kind: TDetailKind;
  state: TMissingDetailState;
  onClose?: () => void;
  // The drawer closes; the settlement page goes back to the costs.
  closeLabel?: string;
  onRetry?: () => void;
}

const UNAVAILABLE_TEXT_KEYS: Record<TDetailKind, string> = {
  cost: "costs.detail.unavailable",
  settlement: "settlement.detail.unavailable",
};

const ICONS = { cost: "billSplit", settlement: "billStack" } as const;

// In place of a cost or settlement its link names but that did not load (see
// getMissingDetailState): a way out instead of an endless spinner or a blank
// drawer.
export const MissingDetail = ({
  kind,
  state,
  onClose,
  closeLabel = getLocalizedText("system.close"),
  onRetry,
}: IProps) => {
  if (state === "loading") return <Loading />;

  const isUnavailable = state === "unavailable";

  return (
    <EmptyState
      icon={ICONS[kind]}
      heading={getLocalizedText(
        isUnavailable
          ? UNAVAILABLE_TEXT_KEYS[kind]
          : "settlement.load_failed_title",
      )}
    >
      <Stack vertical alignment="center" spacing="tight">
        {!isUnavailable && (
          <span>{getLocalizedText("costs.overview.load_failed_body")}</span>
        )}
        <Stack distribution="center" spacing="tight">
          {!isUnavailable && onRetry && (
            <Button appearance="outline" onClick={onRetry}>
              {getLocalizedText("try.again")}
            </Button>
          )}
          {onClose && (
            <Button appearance="outline" onClick={onClose}>
              {closeLabel}
            </Button>
          )}
        </Stack>
      </Stack>
    </EmptyState>
  );
};
